import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class Cashback {
  static endpoints = {
    index: `${baseUrl}/cashback`
  }

  static paginators = {
    all: (data)=> axios.get(this.endpoints.index, {params: data}).then((response)=> response.data.programs.items),
  };

  static checkUrl(id, data) {
    return axios.post(`${this.endpoints.index}/${id}/check`, data).then((response)=> response.data.commision);
  };

}